import CheckinEntryAutoEntryCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/CheckinEntryFormStep/AutoEntry/CheckinEntryAutoEntryCompleted'
import CheckinEntryAutoEntryPending from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/CheckinEntryFormStep/AutoEntry/CheckinEntryAutoEntryPending'
import { MaintenanceForwardingsCheckinEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'

export const checkinEntryOptions: {
  [K in MaintenanceForwardingsCheckinEntryStepOptions]: {
    title: string
    description: string | undefined
    components: {
      pending: React.ComponentType
      completed: React.ComponentType
    }
  }
} = {
  [MaintenanceForwardingsCheckinEntryStepOptions.AutoEntry]: {
    title: 'Auto-locomoção',
    description:
      'Informe um usuário na sua empresa para transporte do equipamento, se aceito, o usuário será notificado.',
    components: {
      pending: CheckinEntryAutoEntryPending,
      completed: CheckinEntryAutoEntryCompleted,
    },
  },
}
